export const skillMockdata = {
  resume_id: 0,
  skill_name: "",
  skill_level: "",
  experience_years: "",
  last_used: "",
  until_now: "",
  description: "",
};

export const initialSkillValues = {
  skill_name: "",
  skill_level: "",
  experience_years: "",
  last_used: "",
  description: "",
  still_used: false,
};

export const levelsOptions = [
  { value: "BEGINNER", label: "Beginner", arabic_label: "مبتدأ" },
  { value: "INTERMEDIATE", label: "Intermediate", arabic_label: "متوسط " },
  { value: "ADVANCE", label: "Advance", arabic_label: "متقدم" },
];
